// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Timestamp$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as InsurancePlanApiModel from "../api-model/InsurancePlanApiModel.bs.js";

function execute(json) {
  var model = DeccoUtils$Catalyst.resolveResult(InsurancePlanApiModel.res_decode(json), "InsurancePlanEntityMapper.res").data;
  var cover = function (data) {
    return List.map((function (e) {
                  return {
                          cover_id: e.cover_id,
                          sum_insured: e.sum_insured
                        };
                }), data);
  };
  return {
          beneficiary_name: model.beneficiary_name,
          policy_number: model.policy_number,
          policy_start_date: Timestamp$Catalyst.make(model.policy_start_date * 1000.0),
          policy_end_date: Timestamp$Catalyst.make(model.policy_end_date * 1000.0),
          coverages: cover(model.coverages)
        };
}

export {
  execute ,
  
}
/* Timestamp-Catalyst Not a pure module */
